import { LitElement, html } from './-global.min.js'

class HHProductSizeQuantities extends LitElement {
  static properties = {
    dimensionsRequired: {
      type: Boolean,
      attribute: 'dimensions-required'
    },
    dimensions: {
      type: Array,
      attribute: 'dimensions',
      default: []
    },
    formId: {
      type: String,
      attribute: 'form-id'
    }
  }

  constructor() {
    super()

    this.quantities = {}
  }

  connectedCallback() {
    super.connectedCallback()
    if (this.dimensions) this.dimensions.map(dimension => this.quantities[dimension] = 0)

    this.querySelectorAll('.js-size-input').forEach(input => input.addEventListener('input', this.handleInputChange.bind(this)))
    this.querySelectorAll('.js-dimension-input').forEach(input => input.addEventListener('input', this.onDimensionInput.bind(this)))
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.querySelectorAll('.js-size-input').forEach(input => input.removeEventListener('input'))
    this.querySelectorAll('.js-dimension-input').forEach(input => input.removedEventListener('input'))
  }

  get totalQuantity () {
    return Object.keys(this.quantities).map(dimension => this.quantities[dimension])
      .reduce((a, b) => a  +b, 0)
  }

  firstUpdated () {
    if (this.dimensions) {
      this.validateSizeQuantity()
    } else {
      this.validateDimensions()
    }
  }

  handleInputChange (e) {
    const { value, dataset: { property } } = e.target
    this.quantities[property] = Math.max(Number(value), 0)

    this.validateSizeQuantity()
  }

  validateSizeQuantity () {
    if (!this.dimensionsRequired) return

    this.dispatchEvent(
      new CustomEvent('changeQuantity', {
        bubbles: true,
        composed: true,
        detail: {
          value: this.totalQuantity
        }
      })
    )

    document.querySelectorAll(`#${this.formId} hh-button-wrapper`).forEach(el => {
      if (this.totalQuantity === 0) {
        el.setAttribute('disabled', true)
      } else {
        el.removeAttribute('disabled')
      }
    })
  }

  onDimensionInput () {
    if (!this.dimensionsRequired) return

    this.validateDimensions()
  }

  validateDimensions () {
    const dimensionsRequired = Array.from(this.querySelectorAll('.js-dimension-input')).some(input => !input.value)

    document.querySelectorAll(`#${this.formId} hh-button-wrapper`).forEach(el => {
      if (dimensionsRequired) {
        el.setAttribute('disabled', true)
      } else {
        el.removeAttribute('disabled')
      }
    })
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-size-quantities', HHProductSizeQuantities)
